export default __webpack_public_path__ + "static/media/skyward_spine.e81931a5.png";